<template>
  <b-alert show variant="info" class="ayuda-historico">
    <a href="javascript:void(0)" class="ayuda-titulo" v-on:click="visible = !visible">
      <b-icon icon="info-circle"></b-icon>
      ¿Cómo llegan los documentos al historial?
      <b-icon :icon="visible ? 'chevron-up' : 'chevron-down'"></b-icon>
    </a>
    <b-collapse v-model="visible">
      <ul class="ayuda-lista">
        <li><b>Cada archivo que se sube queda guardado aquí.</b> Por eso también vas a ver el documento que está vigente hoy, no solo los antiguos.</li>
        <li><b>Al subir un archivo nuevo para un documento</b> {{ textoEntidad }}, el anterior no se pierde: queda en el historial tal como estaba (aprobado, vencido, pendiente, etc.).</li>
        <li><b>Excepción: los documentos rechazados.</b> Si el documento estaba <b>rechazado</b> y se sube uno nuevo en su reemplazo, el rechazado <b>no</b> queda en el historial.</li>
        <li><b>Si se elimina un documento,</b> también desaparece del historial, y en su lugar vuelve a quedar vigente el archivo que se había subido antes.</li>
        <li v-if="entidad == 'trabajador'"><b>Si se elimina un trabajador,</b> también se elimina todo su historial de documentos.</li>
        <li><b>Solo verás</b> los tipos de documento que están activos y los de las sucursales a las que tienes acceso.</li>
      </ul>
    </b-collapse>
  </b-alert>
</template>

<script>
export default {
  name: 'AyudaHistorico',
  props: ['entidad'],
  data() {
    return {
      visible: false
    }
  },
  computed: {
    textoEntidad() {
      const textos = {
        empresa: 'de la empresa',
        trabajador: 'del trabajador',
        vehiculo: 'del vehículo'
      };
      return textos[this.entidad] || '';
    }
  }
}
</script>

<style scoped>
  .ayuda-historico {
    margin-bottom: 15px;
  }
  .ayuda-titulo {
    font-weight: bold;
    color: inherit;
  }
  .ayuda-lista {
    margin: 10px 0 0 0;
    padding-left: 20px;
  }
  .ayuda-lista li {
    margin-bottom: 5px;
  }
</style>
